'use client';
import cn from 'classnames';
import Image from 'next/image';

import NotchImg from 'public/notch.svg';
import './Notch.style.scss';

type NotchProps = {
  className?: string;
};

function Notch(props: NotchProps) {
  const { className = '' } = props;

  return (
    <Image
      className={cn('Notch', className)}
      src={NotchImg}
      alt='Decorative notch'
      height={45}
      width={102}
      style={{ objectFit: 'contain' }}
    />
  );
}

export default Notch;
